export const FEATURE_FLAGS_COLLECTION = "featureFlagsSekolah";
